import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost' | 'success';
  fullWidth?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  fullWidth = true,
  className = '',
  children,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'relative flex items-center justify-center px-6 py-4 text-cta font-heading font-bold rounded-2xl transition-all duration-300 overflow-hidden min-h-[52px]';
  const variants = {
    primary: 'bg-brand-blue text-white shadow-[0_4px_14px_0_rgba(107,155,210,0.39)] hover:shadow-[0_6px_20px_rgba(107,155,210,0.23)] hover:-translate-y-0.5 active:translate-y-0 disabled:bg-gray-300 disabled:text-gray-500 disabled:shadow-none disabled:hover:translate-y-0',
    success: 'bg-brand-green text-white shadow-[0_4px_14px_0_rgba(125,184,158,0.39)] hover:shadow-[0_6px_20px_rgba(125,184,158,0.23)] hover:-translate-y-0.5 active:translate-y-0 disabled:bg-gray-300 disabled:text-gray-500 disabled:shadow-none disabled:hover:translate-y-0',
    outline: 'border-2 border-brand-blue text-brand-blue hover:bg-blue-50 active:scale-[0.98]',
    ghost: 'text-gray-500 hover:text-gray-700 hover:bg-gray-100 active:scale-[0.98]'
  };
  return <motion.button whileTap={disabled ? {} : {
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} disabled={disabled} {...props} data-id="element-329">
      {children}
    </motion.button>;
}